import { render, staticRenderFns } from "./copysmsconfig.vue?vue&type=template&id=34c7f25c&"
import script from "./copysmsconfig.vue?vue&type=script&lang=ts&"
export * from "./copysmsconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copysmsconfig.vue"
export default component.exports